import React, { useEffect, useRef }  from "react";
import "@aurodesignsystem/auro-select";
import "@aurodesignsystem/auro-menu";
import "@aurodesignsystem/auro-combobox";
import "@aurodesignsystem/auro-dropdown";
import "@aurodesignsystem/auro-input";
import "@aurodesignsystem/auro-hyperlink";
import "./MoreTabEdit.scss";
import appSettings from "../../appSettings.js";
import { useEventType } from "../../providers/EventTypeProvider";
import * as SubActionConstant from "../../constants/SubActionConstant";
import * as DropdownConstant from "../../constants/DropdownConstants";
import { deriveHtmlCodedTitle } from "./UpdateSubAction";

interface MoreTabEditProps {
  onMoreTabData: any;
  resetInputs: any;
  moreOtsData: any;
  specialEventsAllowed: boolean;
  aircraftIsAirborne: boolean;
  airline: string;
};

const MoreTabEdit = (props: MoreTabEditProps) => {
    const [viewInputsFerryFlight, setViewInputsFerryFlight] = React.useState(false);
    const [viewInputsFieldTrip, setviewInputsFieldTrip] = React.useState(false);
    const [specialEventCategory, setSpecialEventCategory] = React.useState(""); 
    const [fromLocation, setFrom] = React.useState("");
    const [toLocation, setTo] = React.useState("");
    const [isToLocationValid, setToLocationValid] = React.useState(false);
    const [isFromLocationValid, setFromLocationValid] = React.useState(false);
    const [eventType, setEventType] = React.useState("");
    const [previousEventType, setPreviousEventType] = React.useState("");
    const [eventTypeCategory, setEventTypeCategory] = React.useState("");
    const { eventTypes, selectedEventType } = useEventType();

    const categoryRef = useRef(null);
    const eventTypesRef = useRef(null);
    const ferryFlightTitle = `Spec flt per. from ${fromLocation} to ${toLocation}`;
    const fieldTripTitle = `Field trip from ${fromLocation} to ${toLocation}`;
    const ferryFlightPdf = appSettings.FERRY_FLIGHT_PDF;

    useEffect(() => {
      const control = categoryRef.current;
      
      const handleSelectedOption = (elem: any) => {
        setSpecialEventCategory(elem.target.value);
        if (elem.target.value === DropdownConstant.FERRY_FLIGHT){
          setFrom("");
          setTo("");
          setFromLocationValid(false);
          setToLocationValid(false);
          setviewInputsFieldTrip(false);
          setViewInputsFerryFlight(true);
        }
        else if (elem.target.value === DropdownConstant.FIELD_TRIP){
          setFrom("");
          setTo("");
          setFromLocationValid(false);
          setToLocationValid(false);
          setViewInputsFerryFlight(false);
          setviewInputsFieldTrip(true);
        }
      };

    if (control) {
        control.addEventListener('selectedOption', handleSelectedOption);
    }

      // Clean up function
      return () => {
        if (control)
        { control.removeEventListener('selectedOption', handleSelectedOption); }
      };
    }, []); // Empty dependency array means this effect runs once on mount and clean up on unmount

    useEffect(() => {
      const control = eventTypesRef.current;
      
      const handleEventTypeSelectedOption = (elem: any) => {
        setEventType(elem.target.value);
        let matchingItem = eventTypes.find(item => item.Name === elem.target.value);
        if (matchingItem)
        { 
          setEventTypeCategory(matchingItem.Category);
        }
      };

    if (control) {
        control.addEventListener('selectedOption', handleEventTypeSelectedOption);
    }

      // Clean up function
      return () => {
        if (control)
        { control.removeEventListener('selectedOption', handleEventTypeSelectedOption); }
      };
    }, []); // Empty dependency array means this effect runs once on mount and clean up on unmount

    React.useEffect(() => {
      validateForm();
    }, [isToLocationValid, isFromLocationValid, eventType, eventTypeCategory]);

  const showEventType = (item: any) => {
    if (item.IsActive){
      if (props.airline === "QX"){ // always show all event types for QX - no special handling for Airborne
        return true;
      }
      if (props.aircraftIsAirborne && !item.IsForAirborne){ // show event types that are is not for airborne
        return true;
      } else if (!props.aircraftIsAirborne && item.Category !== "NotApplicable" && !item.IsForAirborne){
        return true;
      }
    }
    else{
      return false;
    }
  };  

  const validateForm = () => {
    if(specialEventCategory != "" && isToLocationValid && isFromLocationValid){
      //valid special event
      const moreTabData = {
        moreTabValid: true,
        moreEventTitle: specialEventCategory===DropdownConstant.FERRY_FLIGHT? ferryFlightTitle : fieldTripTitle,
        specialEventCategory: specialEventCategory,
        fromLocation: fromLocation,
        toLocation: toLocation,
        subAction: SubActionConstant.SPECIAL_EVENT
      };
      props.onMoreTabData(moreTabData);
    }
    else if(previousEventType != eventType){
      //valid event type
      const moreTabData = {
        moreTabValid: true,
        moreEventTitle: deriveHtmlCodedTitle("Event type updated", eventType, previousEventType),
        eventType: props.aircraftIsAirborne && props.airline !== "QX"? props.moreOtsData?.EventType : eventType,
        eventTypeCategory:  props.aircraftIsAirborne && props.airline !== "QX"? props.moreOtsData?.EventTypeCategory : eventTypeCategory,
        eventTypeTo: props.aircraftIsAirborne && props.airline !== "QX"? eventType : props.moreOtsData?.EventTypeTo,
        eventTypeCategoryTo: props.aircraftIsAirborne && props.airline !== "QX"? eventTypeCategory : props.moreOtsData?.EventTypeCategoryTo,
        subAction: SubActionConstant.EVENT_TYPE_CHANGE
      };
      props.onMoreTabData(moreTabData);
    }
    else{
      //invalid
      const moreTabData = {
        moreTabValid: false
      };
      props.onMoreTabData(moreTabData);
    }
  };

    const handleFromLocationValue = (event: any) => { 
      setFrom(event.target.value.toUpperCase());
      console.log("from location: ", event.target);
      setFromLocationValid(event.target.isValid);
  };

  const handleToLocationValue = (event: any) => {
      setTo(event.target.value.toUpperCase());
      setToLocationValid(event.target.isValid);
  };

  useEffect(() => { 
    if(props.resetInputs){
      setFrom("");
      setTo("");
      setFromLocationValid(false);
      setToLocationValid(false);
      setViewInputsFerryFlight(false);
      setviewInputsFieldTrip(false);
      setSpecialEventCategory("");
      setEventType(props.aircraftIsAirborne && props.moreOtsData?.EventTypeTo? props.moreOtsData?.EventTypeTo:props.moreOtsData?.EventType);
      setPreviousEventType(props.aircraftIsAirborne && props.moreOtsData?.EventTypeTo? props.moreOtsData?.EventTypeTo:props.moreOtsData?.EventType);
      setEventTypeCategory(props.aircraftIsAirborne && props.moreOtsData?.EventTypeCategoryTo? props.moreOtsData?.EventTypeCategoryTo:props.moreOtsData?.EventTypeCategory);
    }
  }, [props.resetInputs, props.moreOtsData] );

    return (
        <React.Fragment>
            <div className="more-tab-content">
                <div className="select">
                <auro-select placeholder="Event type" ref={eventTypesRef} value={eventType} 
                disabled={specialEventCategory.length>0 ? "disabled" : null}>
                { eventType.length>0 && <span slot="label">Event type</span>} 
                <auro-menu>
                    {Array.isArray(eventTypes) &&
                      eventTypes?.map((item: any) => (
                        showEventType(item) ? (
                          <auro-menuoption value={item.Name}
                                key={item.Name}
                                id={item.Name}
                          >{item.Name}</auro-menuoption>
                        ) : null
                      ))
                    }
                </auro-menu>
              </auro-select>
                </div>
                <div className="select">
                  <auro-select placeholder="Special events" ref={categoryRef} value={specialEventCategory}
                     disabled={previousEventType != eventType || props.specialEventsAllowed === false ? "disabled" : null}>
                    { specialEventCategory.length>0 && <span slot="label">Special events</span>}
                    <auro-menu>
                      <auro-menuoption value={DropdownConstant.FERRY_FLIGHT}>Spec flt per.</auro-menuoption>
                      <auro-menuoption value={DropdownConstant.FIELD_TRIP}>Field trip</auro-menuoption>
                    </auro-menu>
                  </auro-select>
              </div>
              {(viewInputsFerryFlight || viewInputsFieldTrip) &&
              <div className="airport-input">
                <auro-input
                  activeLabel="true"
                  validateOnInput
                  required
                  bordered
                  maxlength="3"
                  minLength="3"
                  pattern="[a-zA-Z]{3}"
                  setCustomValidity="Enter a valid station"
                  value={fromLocation}
                  onInput={handleFromLocationValue}
                  >
                  <span className="label" slot="label">From</span>
                </auro-input>
                <auro-input
                  activeLabel="true"
                  validateOnInput
                  required
                  bordered
                  maxlength="3"
                  minLength="3"
                  pattern="[a-zA-Z]{3}"
                  setCustomValidity="Enter a valid station"
                  value={toLocation}
                  onInput={handleToLocationValue}
                  >
                  <span className="label" slot="label">To</span>
                </auro-input>
              </div>
              }
              {viewInputsFerryFlight &&
              <div className="special-flight-permit">
                <p className="permit-title">Special flight permit</p>
                <auro-hyperlink href= {ferryFlightPdf} target="_blank" rel="noopener noreferrer">Fill out special flight permit</auro-hyperlink>
              </div>
              }
            </div>
        </React.Fragment>
    );

}
export default MoreTabEdit;
